import { RefObject, useEffect, useRef, useState, useTransition } from 'react';

export type UseComponentSizeReturn = [
  RefObject<HTMLElement | null>,
  number,
  boolean,
];

export const useComponentWidth = (): UseComponentSizeReturn => {
  const parentRef = useRef<HTMLElement>(null);
  const [width, setWidth] = useState<number>(0);
  const [isTransitioning, startTransition] = useTransition();
  useEffect(() => {
    if (parentRef.current) {
      const observer = new ResizeObserver(size => {
        startTransition(() => {
          setWidth(size[0].contentRect.width);
        });
      });

      observer.observe(parentRef.current);
      return () => observer.disconnect();
    }
    return () => {};
  }, []);

  return [parentRef, width, isTransitioning];
};
